import { Icon, iIconProps } from '../../atoms/Icon';
import { Typography } from '../Typography';

type infoItem = {
  icon: iIconProps;
  textWeight: 'bold' | 'normal';
  text: string;
};

interface iEventInfoListProps {
  items: infoItem[];
}

function EventInfoList({ items }: iEventInfoListProps) {
  return (
    <ul className='flex flex-col gap-[18px] md:flex-row'>
      {items.map((item, index) => (
        <li key={index} className='flex gap-sm'>
          <Icon {...item.icon} className='h-6 w-6 text-mono-color-darkest' />
          <Typography weight={item.textWeight}>{item.text}</Typography>
        </li>
      ))}
    </ul>
  );
}

export { EventInfoList };
export type { infoItem };

